<script>
    import { Router, Route, Link } from "svelte-navigator";
    import Product from "./Product.svelte";
    import Category from "./Category.svelte";
    import TopProducts from "../components/TopProducts.svelte";
    import TopWhiskeys from "../components/TopWhiskeys.svelte";
    import StickyHeader from "../components/StickyHeader.svelte";
    import Footer from "../components/Footer.svelte";
    import TopWines from "../components/TopWines.svelte";

    let showHeader = true;
</script>

<main>
    <Router>
        <StickyHeader />

        <div class="mainContainer ui grid">
            <div class="toCo sixteen wide column" />
            <!-- store home -->
            <Route path="/*">
                <div class="re sixteen wide column" />
                <div class="sixteen wide column">
                    <TopProducts />
                </div>

                <div class="sixteen wide column">
                    <TopWhiskeys />
                </div>

                <div class="sixteen wide column">
                    <TopWines />
                </div>
            </Route>
            <!-- store home -->

            <Route path="product/*">
                <div class="sixteen wide column">
                    <Product />
                </div>
            </Route>

            <Route path="category/*">
                <div class="sixteen wide column">
                    <Category />
                </div>
            </Route>
        </div>

        <Footer />
    </Router>
</main>

<style>
    .grid {
        min-height: 25em;
        padding-top: 3em;
        font-size: 10px;
        max-width: 110em;
        margin: auto !important;
    }

    .toCo {
        height: 5em;
    }

    @media only screen and (min-width: 768px) {
        .toCo {
            height: 10em;
        }
    }
</style>
